module.exports = __webpack_public_path__ + "img/ang22.64b77ade.png";